import React from 'react';
import { useLocation } from "react-router-dom";

import { Page } from "src/pages/_partials/Layout";
import NavBar2 from 'src/componets/NavBar2';
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";
import { isActiveUrl } from "src/helpers/UrlHelpers";

interface PropsInterface {
  className?: string;
  children: React.ReactNode
}

const PageLayout: React.FC<PropsInterface> = (props) => {
  const PAGES: {[index: number]: any} = {
    1: {
      id: 1,
      name: 'Bundles',
      icon: 'fa-brands fa-app-store-ios',
      url: callrecorderUrls.bundlesPath({ order_by: 'prod_env' })
    }
  };

  const PAGE_IDS = Object.keys(PAGES).map(id => parseInt(id, 10));

  const { pathname } = useLocation();
  const pageId = PAGE_IDS.find(id => isActiveUrl(PAGES[id].url, pathname));

  return (
    <Page className={props.className}>
      <NavBar2 items={PAGES} itemIds={PAGE_IDS} activeId={pageId} />

      <div className='v-layout--body'>
        {props.children}
      </div>
    </Page>
  );
}

export default PageLayout;
